<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container class="px-10 pt-8">
        <p class="subtitle-1 font-weight-bold mb-2">
          Batch Reject Payment Request
        </p>
        <v-row>
          <v-col class="py-0" cols="12" sm="12" md="3">
            <p class="caption">Total:</p>
          </v-col>
          <v-col class="py-0" cols="12" sm="12" md="9">
            <p class="caption font-weight-bold">
              {{ formatCurrency(total) }}
            </p>
          </v-col>
        </v-row>
        <v-divider class="my-4"></v-divider>
        <!-- <transition name="fade" mode="out-in"> -->
        <div v-if="step == 1" key="1">
          <v-row>
            <v-col class="py-2" cols="12" sm="12" md="12">
              <p>Are you sure you would like to reject the payment requests?</p>
            </v-col>
          </v-row>

          <v-expansion-panels class="pb-2 my-2" accordion flat>
            <v-expansion-panel>
              <v-expansion-panel-header class="py-2 body-2"
                >Payment Requests
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-divider class="mb-0"></v-divider>

                <v-list-item
                  v-for="paymentRequest in paymentRequests"
                  :key="`payment_request_${paymentRequest.refNo}`"
                  three-line
                >
                  <v-list-item-avatar color="grey">
                    <p class="caption white--text">
                      {{ paymentRequest.refNo }}
                    </p>
                    <!-- <v-icon class="grey lighten-1" dark> mdi-cash </v-icon> -->
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="body-2">
                      Total amount:
                      {{
                        formatCurrency(paymentRequest.total)
                      }}</v-list-item-title
                    >
                    <v-list-item-subtitle class="caption">
                      Category:
                      {{ paymentRequest.category }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle
                      v-if="paymentRequest.amountPaid"
                      class="caption"
                    >
                      Description:
                      {{ paymentRequest.description }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-else class="caption grey--text">
                      No description provided
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mb-1"></v-divider>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="font-weight-bold"
              color="primary"
              text
              @click="finish()"
              >Yes</v-btn
            >
            <v-btn
              class="font-weight-bold"
              color="grey darken-1"
              text
              @click="cancel"
              >No</v-btn
            >
          </v-card-actions>
        </div>
      </v-container>
    </v-card>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { formatCurrency } from '../../util/currency'
export default {
  data() {
    return {
      formatCurrency,
      dialog: false,
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      loading: true,
      paymentRequests: [],
      total: 0,
      step: 1
    }
  },
  methods: {
    async open({ paymentRequests }) {
      this.loading = true
      this.dialog = true
      this.paymentRequests = paymentRequests
      this.total = paymentRequests.reduce(
        (total, paymentRequest) => total + paymentRequest.total,
        0
      )
      this.step = 1

      this.loading = false
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async finish() {
      this.loading = true
      if (
        await this.$store.dispatch('payments/batchRejectPaymentRequests', {
          paymentRequests: this.paymentRequests
        })
      ) {
        this.$root
          .$confirm({
            title: 'Reject Batch Payment Request',
            message: `The payment request has been rejected.`,
            reconfirmOnly: true,
            confirmText: 'OK'
          })
          .then(() => {
            this.loading = false
            this.dialog = false
            this.resolve(this.paymentRequests)
          })
      } else {
        this.$root
          .$confirm({
            title: 'Reject Batch Payment Request',
            message: `There was an error processing your request.`,
            reconfirmOnly: true,
            confirmText: 'OK'
          })
          .then(() => {
            this.loading = false
          })
      }
    },
    cancel() {
      this.dialog = false
      this.loading = false
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.v-expansion-panel {
  border-style: solid;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.12);
}
</style>
